let isAlreadyCalled = false;

export const initComments = (coralContainer, dataEdtn) => {
  const innerCoralContainer = coralContainer.find('#coral-shadow-container');
  // const innerCoralContainer = coralContainer.querySelector(
  //   '#coral-shadow-container',
  // );
  const showCoralCommentsBtn = document.querySelector('#show-comments');
  // const showCoralCommentsBtnTopComments = document.querySelector('.m1-top-comments__empty > span');
  const topCommentsEmptyBlock = document.querySelector('.m1-top-comments');
  // const commentButtons = document.querySelectorAll('.m1-article-meta_comments');

  const updateMiddleBtn = (count) => {
    const middleAnchorSelector = document.querySelector(
      '.m1-article-meta_comments-middle',
    );
    const prefix = middleAnchorSelector.querySelector(
      '.top-counter-comments-prefix',
    );
    const suffix = middleAnchorSelector.querySelector(
      '.top-counter-comments-suffix',
    );

    const isBr = ['br', 'ev_br'].includes(dataEdtn);

    if (count === 0) {
      prefix.classList.add('hidden');
      suffix.textContent = isBr ? 'COMENTE' : 'Comment';
    } else if (count === 1) {
      prefix.classList.remove('hidden');
      prefix.textContent = isBr ? 'VER' : 'View';
      suffix.textContent = isBr ? 'COMENTÁRIO' : 'Comment';
    } else {
      prefix.classList.remove('hidden');
      prefix.textContent = isBr ? 'VER' : 'View';
      suffix.textContent = isBr ? 'COMENTÁRIOS' : 'Comments';
    }
  };

  if (['ra_us', 'ev_us', 'us', 'br', 'ev_br'].includes(dataEdtn)) {
    const onReady = () => {
      const counterSelector = document.querySelector('.coral-count');
      if (!counterSelector) return;
      const bottomAnchorSelector = document.querySelector(
        '.m1-article-meta_comments-bottom',
      );
      const middleAnchorSelector = document.querySelector(
        '.m1-article-meta_comments-middle',
      );
      const m1CoralCommentAmount = parseInt(
        counterSelector.getAttribute('data-coral-count'),
        10,
      );
      if (isNaN(m1CoralCommentAmount) && isAlreadyCalled) return;
      const hasCount = Number.isFinite(m1CoralCommentAmount);
      const isEmpty = hasCount && m1CoralCommentAmount === 0;
      const isSingle = hasCount && m1CoralCommentAmount === 1;
      const isMany = hasCount && m1CoralCommentAmount > 1;

      // console.log('CONSOLE COMMENTS', isEmpty, isMany, showCoralCommentsBtn);
      if (isEmpty && !isAlreadyCalled) {
        const anchorSelectors = document.querySelectorAll(
          '.m1-article-meta_comments',
        );
        if (bottomAnchorSelector instanceof Element) {
          bottomAnchorSelector.querySelector(
            '.top-counter-comments-label',
          ).textContent = i18n.comment_js;
        } else if (isSingle) {
          bottomAnchorSelector.querySelector(
            '.top-counter-comments-label',
          ).textContent = 'Go to comment';
        }

        if (showCoralCommentsBtn) {
          showCoralCommentsBtn.querySelector(
            '.coral-coment-button-text',
          ).textContent = 'View all comments';
        }
      } else if (isMany) {
        if (showCoralCommentsBtn instanceof Element) {
          showCoralCommentsBtn.style.visibility = 'visible';
        }
        bottomAnchorSelector.querySelector(
          '.top-counter-comments-label',
        ).textContent = `Go to comments`;
      }
    };

    const counterSelector = document.querySelector('.coral-count');
    if (counterSelector) {
      const mo = new MutationObserver(() => {
        const count = parseInt(
          counterSelector.getAttribute('data-coral-count'),
          10,
        );
        if (!Number.isFinite(count)) return;

        if (!isAlreadyCalled) onReady();

        updateMiddleBtn(count);
      });

      mo.observe(counterSelector, {
        attributes: true,
        attributeFilter: ['data-coral-count'],
      });

      const initialCount = parseInt(
        counterSelector.getAttribute('data-coral-count'),
        10,
      );
      if (Number.isFinite(initialCount)) {
        onReady();
        updateMiddleBtn(initialCount);
      }
    }
  }
};
